/* eslint-disable */
import {BhImage} from './BhImage';
import {Ad} from './Ad';
/**
* @description Interface for Avensia.Commerce.Web.Models.Ads.LeaderBoardAd
*/
export interface LeaderBoardAd extends Ad {
	leaderboardImage: BhImage;
}
export const isLeaderBoardAd = (model: unknown): model is LeaderBoardAd => (model as LeaderBoardAd).component === 'Bygghemma.Commerce.Web.Models.Ads.LeaderBoardAd';

